'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FloAlt = function FloAlt(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ['color', 'size']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 226.8 226.8',
      width: size,
      height: size,
      fill: color
    }, otherProps),
    _react2.default.createElement('path', { d: 'M113.4 0C50.8 0 0 50.8 0 113.4s50.8 113.4 113.4 113.4S226.8 176 226.8 113.4 176 0 113.4 0zM88.116 64.519c1.307-8.311 13.149-18.763 22.287-25.852.715-.556 1.614-.857 2.514-.942.01-.01.01-.021.01-.021.163-.01.311-.021.474-.01.16-.01.33 0 .492.01v.021c.91.085 1.809.386 2.513.942 9.149 7.089 20.97 17.541 22.277 25.852 1.328 8.309-1.498 13.663-1.498 13.663-11.375 21.236-14.031 44.689-13.988 51.253-4.882 2.4-14.735 2.4-19.575 0 0-6.564-2.634-30.018-13.985-51.253.002-.001-2.827-5.354-1.521-13.663zm46.628 66.162c.492 3.123 0-.921 1.253 5.332-13.719 6.876-31.453 6.876-45.183 0 1.136-5.48.92-2.931 1.264-5.332 12.551 6.444 30.158 6.38 42.666 0zm-85.888 7.562c-1.242.467-1.692-.496-1.692-.496s-4.273-8.908-5.215-24.203c-.567-10.411.846-16.214.846-16.214s2.613-11.694 11.651-14.413c2.015-.729 12.551-2.453 17.929 0 6.596 3.009 10.954 5.566 18.74 16.534 7.775 10.963 9.403 29.657 9.403 29.657s-7.679-1.664-9.255-4.404c-1.583-2.755-2.762-6.897-11.726-14.19-4.443-3.62-8.769-1.317-8.769-1.317s-1.756 1.133-1.905 2.761c-.152 1.621-.174 5.268-2.549 9.113-7.583 11.72-15.507 16.422-17.458 17.172zm34.399 24.904c-2.528 1.869-6.521 1.671-9.318 1.161-2.761-.517-4.305-2.337-4.925-3.774-.612-1.692-.612-3.576-.149-5.976.45-2.351.832-4.213 2.953-9.552.206-.488.793-.467 1.094 0 2.591 3.711 4.433 4.886 4.433 4.886s1.692 1.586 4.025 0c2.316-1.565 8.023-10.218 8.023-10.218l7.014 3.087s-3.275 8.653-6.766 13.489c-3.516 4.822-3.877 5.035-6.384 6.897zm47.141 7.732c-3.696 7.138-13.772 16.605-15.036 17.547a3.755 3.755 0 0 1-1.554.666v.021h-.79v-.021a3.79 3.79 0 0 1-1.565-.666c-1.275-.942-11.329-10.409-15.047-17.547-2.783-5.395-4.712-7.732 0-15.89 4.712-8.157 7.219-10.388 7.219-10.388 9.789 1.154 9.789 1.154 19.575 0 0 0 2.485 2.23 7.198 10.388 4.713 8.158 2.794 10.495 0 15.89zm27.414-10.345c-.62 1.438-2.163 3.257-4.946 3.774-2.786.51-6.79.708-9.297-1.161-2.518-1.862-2.868-2.075-6.38-6.897-3.516-4.836-6.791-13.489-6.791-13.489l7.024-3.087s5.697 8.653 8.034 10.218c2.312 1.586 4.025 0 4.025 0s1.841-1.175 4.411-4.886c.322-.467.899-.488 1.105 0 2.131 5.339 2.507 7.201 2.967 9.552.461 2.4.461 4.284-.152 5.976zm27.063-46.989c-.952 15.294-5.236 24.203-5.236 24.203s-.429.963-1.671.496c-1.951-.751-9.896-5.452-17.458-17.171-2.376-3.845-2.397-7.492-2.545-9.113-.152-1.629-1.919-2.761-1.919-2.761s-4.327-2.303-8.77 1.317c-8.975 7.294-10.388 11.436-11.705 14.19-1.328 2.74-9.266 4.404-9.266 4.404s1.608-18.694 9.404-29.657c7.775-10.968 12.144-13.525 18.739-16.534 5.378-2.453 15.914-.729 17.918 0 9.028 2.719 11.662 14.413 11.662 14.413s1.393 5.802.847 16.213z' })
  );
};

FloAlt.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

FloAlt.defaultProps = {
  color: 'currentColor',
  size: '24'
};

exports.default = FloAlt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-cryptocoins/dist/icons/FLO-alt.js
// module id = 1404
// module chunks = 0